<template>
    <span>
      
      <!--<div v-if="isReloading" class='uil-rolling-css loading-nav-spinner' style='transform:scale(0.50); 
        position: absolute; margin: 0 auto; top: 100px; right: 0px; left: 50px;'>
          <div>
            <div></div>
            <div></div>
          </div>
      </div>-->
      <div v-if="isReloading" class="sk-cube-grid">
          <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
          <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
        </div>
      
      <single-modal :id="tableModalConfigs.id" @API="APITabModal = $event" :title="modalTitle" :options="tableModalConfigs">
        <form class="form-horizontal" role="form">
          <div style="padding-bottom: 10px;">
            <div v-if="!emptyTyp" class="form-detail-field form-group">
              <input-w :configs="tableModalInputConfigs.type">
                <label class="col-sm-3 control-label">{{tableModalInputConfigs.type.val}}</label>
                <div v-if="!multipleCodeForPos" class="col-sm-4"><input type="text" class="form-detail form-control" :value="tableModalInputConfigs.type.cod" readonly/></div>
                <div v-else class="col-sm-8">
                  <v-select label="sid" style="width: 100%;" :menuStyle="{position: 'relative','height':'auto'}" :highStyle="{'width': 'max-content'}"
                    
                    :options="codiciList" v-model="selCode" @input="onCodeSelected" :placeholder="$Jed.firstUpperTranslate('select')+' '+$Jed.translate('code')">
                  </v-select> 
                </div>
              </input-w>
            </div>
            <div v-if="!emptyDes" class="form-detail-field form-group">
              <input-w :configs="tableModalInputConfigs.description">
                <label class="col-sm-3 control-label">{{tableModalInputConfigs.description.lbl}}</label>
                <div class="col-sm-8"><textarea id="des_area" :rows="tableModalInputConfigs.description.rows" style="resize: none;" class="form-detail form-control" :value="tableModalInputConfigs.description.val" readonly/></div>
              </input-w>
            </div>
            <cfg cid="modalDetail.feature_area" tag='div'>
              <div v-if="!emptySpe" class="form-detail-field form-group">
                <input-w :configs="tableModalInputConfigs.feature">
                  <label class="col-sm-3 control-label">{{tableModalInputConfigs.feature.lbl}}</label>
                  <div class="col-sm-8"><textarea id="feature_area" :rows="tableModalInputConfigs.feature.rows" style="resize: none;" class="form-detail form-control" :value="tableModalInputConfigs.feature.val" readonly/></div>
                </input-w>
              </div>
            </cfg>
            <div v-if="!emptyPos" class="form-detail-field form-group">
              <input-w :configs="tableModalInputConfigs.position">
                <label class="col-sm-3 control-label">{{tableModalInputConfigs.position.lbl}}</label> 
                <div class="col-sm-3"><input type="text" class="form-detail form-control" :value="tableModalInputConfigs.position.val" readonly/></div>
              </input-w>
            </div>
            <div v-if="!emptyQty" class="form-detail-field form-group">
              <input-w :configs="tableModalInputConfigs.quantity">
                <label class="col-sm-3 control-label">{{tableModalInputConfigs.quantity.lbl}}</label>
                <div class="col-sm-3"><input type="text" class="form-detail form-control" :value="tableModalInputConfigs.quantity.val" readonly/></div>
              </input-w>
            </div>
            <div v-if="!emptySpi" class="form-detail-field form-group">
              <input-w :configs="tableModalInputConfigs.codSost">
                <label class="col-sm-3 control-label">{{tableModalInputConfigs.codSost.lbl}}</label>
                <div class="col-sm-3"><input type="text" class="form-detail form-control" :value="tableModalInputConfigs.codSost.val" readonly/></div>
              </input-w>
            </div>
            <div v-if="!emptyNot" class="form-detail-field form-group">
              <input-w :configs="tableModalInputConfigs.not">
                <label class="col-sm-3 control-label">{{tableModalInputConfigs.not.lbl}}</label>
                <div class="col-sm-8"><textarea id="notes_area" :rows="tableModalInputConfigs.not.rows" style="resize: none;" class="form-detail form-control" :value="tableModalInputConfigs.not.val" readonly/>
                </div>
              </input-w>
            </div>
            <div v-if="!emptyVal" class="form-detail-field form-group">
              <label class="col-sm-3 control-label">{{tableModalInputConfigs.validity.lbl}}</label>
              <div class="col-sm-8"><grid :columns="valListCfg.columns" :source.sync="valList" :options="valGridOptions" 
                  :lang="$root.token.idLingua" :name="valListCfg.title" :selectParameter="$Behaviors.focusBy()" 
                  :select="focus"></grid>
              </div>
            </div>
            <div v-if="!emptyDoc" class="form-detail-field form-group">
              <label class="col-sm-3 control-label">{{tableModalInputConfigs.documents.lbl}}</label>
              <div class="col-sm-8"><grid :columns="docListCfg.columns" :source.sync="docList" :options="docGridOptions" 
                  :lang="$root.token.idLingua" :name="docListCfg.title" :selectParameter="$Behaviors.focusBy()" 
                  :select="focus"></grid>
              </div>
            </div>
            <div v-if="!emptyAttr" class="form-detail-field form-group">
              <label class="col-sm-3 control-label">{{tableModalInputConfigs.attributes.lbl}}</label>
              <div class="col-sm-8"><grid :columns="attrListCfg.columns" :source.sync="attrList" :options="attrGridOptions" 
                  :lang="$root.token.idLingua" :name="attrListCfg.title" :selectParameter="$Behaviors.focusBy()" 
                  :select="focus"></grid>
              </div>
            </div>
          </div>

          <!--Area acquisto-->
          <cfg v-if="codeSelected && !this.$root.blockCart" cid="modalDetail.purchase_area" tag='div'>
            <div style="padding-top: 10px; border-top: 0.5px solid rgb(204, 204, 204); box-shadow: 1px -1px rgb(228, 243, 251);">
              <!--Campo prezzo-->
              <div v-if="!emptyPri" class="form-detail-field form-group">
                <input-w :configs="tableModalInputConfigs.price">
                  <label class="col-sm-3 control-label">{{tableModalInputConfigs.price.lbl}}</label>
                  <div class="col-sm-3"><input type="text" class="form-detail form-control" :value="tableModalInputConfigs.price.val" readonly/></div>
                </input-w>
              </div>
              <!--Campo quantità e inserimento in carrello-->
              <div v-show="salable" class="form-detail-field form-group"> 
                <label class="col-sm-3 control-label">{{$Jed.firstUpperTranslate('purchase')}}</label>
                <div class="col-sm-3" style="margin-top: 1px;">
                  <div class="input-group">
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default btn-number-modal" style="background-color: #f4f4f4 !important; color: #444 !important; border-color: #ddd;" data-type="minus-modal" data-field="modalquant[1]">
                          <span :class="this.$root.icons.minus"></span>
                      </button>
                    </span>

                    <input type="number" id="modalquantitaId" name="modalquant[1]" class="form-control input-number-modal" style="text-align: center;" value="">

                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default btn-number-modal" style="background-color: #f4f4f4 !important; color: #444 !important; border-color: #ddd;" data-type="plus-modal" data-field="modalquant[1]">
                          <span :class="this.$root.icons.plus"></span>
                      </button>
                    </span>
                  </div>
                </div>
                <div class="col-sm-1">
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <button type="button" class="btn" @click="putInCart()" style="padding: 2.5px 8px; background-color: #f4f4f4; color: #444; border-color: #ddd; font-size: 20px;">
                      <span :class="this.$root.icons.cart_in"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="!salable" class="form-detail-field form-group">
              <label class="col-sm-3 control-label">{{$Jed.firstUpperTranslate('purchase')}}</label>
              <div class="col-sm-3" style="padding-top: 7px;">{{$Jed.firstUpperTranslate('not purchasable')}}</div>
            </div>
          </cfg>
        </form>
      </single-modal>

      <component v-show="!isReloading && activeData != null" :is="layout" :activeData="activeData" :focus="focus"></component> 
     
    </span>
</template>
<script>
import { eventBus } from "../../eventbus.js";

import GridLayout from "../sub-views/Grid.vue";
import Detail from "../sub-views/Detail.vue";
import ImgLayout from "../sub-views/Image.vue";
import TableLayout from "../sub-views/Table.vue";

import DynButton from "../dynamic/DynButton.vue";
import Cfg from "../dynamic/ConfigurableComponent.vue";
import SingleModal from "../dynamic/modalWrapper/SingleModal.vue"
import InputW from '../dynamic/inputWrapper/inputWrapper.vue'
import Grid from "../dynamic/jqwGridWrapper/jqwGridWrapper.vue";
import utils from '../../../utils/utilities.js'
import vSelect from "../dynamic/vueSelectWrapper/components/Select.vue"

export default {
  components: {
    GridLayout,
    Detail,
    ImgLayout,
    TableLayout,

    DynButton,
    Cfg,
    SingleModal,
    InputW,
    Grid,
    vSelect
  },
  props: {
    right: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    //azzero l'ultima altezza memorizzata della griglia 
    this.$store.commit("setLastHeight", null);
    this.$emit("togglesupport", false);
    
    if (this.ignoreIdle) {
      this.ignoreIdle = false;
    } else {
      //navigo al nodo che è passato come parametro nell'url
      this.$nextTick(function() {
        var id = this.$root.decode(this.$route.params.id)
        this.$root.navigateTo(id);
      });
    }
    if (this.$route.params.focus != null && this.$route.params.focus != "") {
      this.focusChangeDetected();
    }
  },
  data: function() {
    var vm = this;
    return {
      ignoreIdle: false,
      activeData: null,
      focus: null,
      layout: null,
      layoutMap: {
        4: "ImgLayout",
        1: "GridLayout",
        2: "TableLayout",
        3: "Detail"
      },

      isReloading: false,
      modalTitle: "",
      tableModalConfigs:{
        showConfirmButton: false,
        showCancelButton: false,
        blockBlur: true,
        id: 'detailModal'
      }, 
      tableModalInputConfigs:{
        type:{
          id:"type", 
          val: '',
          cod: ''
        },
        description:{
          id:"descrField",
          lbl: vm.$Jed.firstUpperTranslate('description'), 
          val: '',
          rows: ''
        },
        feature:{
          id:"featureField",
          lbl: vm.$Jed.firstUpperTranslate('specification'),
          val: '',
          rows: ''
        },
        position:{
          id:"pos",
          lbl: vm.$Jed.firstUpperTranslate('position'),
          val: ''
        },
        quantity:{
          id:"qty",
          lbl: vm.$Jed.firstUpperTranslate('qty'),
          val: ''
        },
        codSost:{
          id:"codSost",
          lbl: vm.$Jed.firstUpperTranslate('substitute code'),
          val: ''
        },
        not:{
          id:"not",
          lbl: vm.$Jed.firstUpperTranslate('note', 2), 
          val: '',
          rows: ''
        },
        price:{
          id:"pri",
          lbl: vm.$Jed.firstUpperTranslate('price'), 
          val: ''
        },
        validity:{
          id:"val",
          lbl: vm.$Jed.firstUpperTranslate('validity'), 
          from: '',
          to: ''
        },
        documents:{
          id:"doc",
          lbl: vm.$Jed.firstUpperTranslate('document', 2)
        },
        attributes:{
          id:"attr",
          lbl: vm.$Jed.firstUpperTranslate('attribute', 2)
        }
        /* vers:{
          id:"vers",
          lbl:"Versione", 
          val: ''
        },
        rev:{
          id:"rev",
          lbl:"Revisione", 
          val: ''
        },
        codAlt:{
          id:"codAlt",
          lbl: 'Cod Alternativo'
          val: ''
        } */
      },
      attrListCfg: {
        ID: "attrTable",
        title: "AttributesGrid",
        label_title: "",
        columns: {
          configs:{
            name: {
              text: "name",
              position: 1,
              visible: true,
              editable: false,
              width: "40%",
              searchable: false,
              sorting: true,
              datafield: "name"
            },
            descr: {
              text: "description",
              position: 2,
              visible: true,
              editable: false,
              width: "60%",
              searchable: false,
              sorting: true,
              datafield: "descr"
            }
          }
        }
      },
      docListCfg: {
        ID: "docTable",
        title: "DocumentsGrid",
        label_title: "",
        columns: {
          configs:{
            thumb: {
              text: "thumbnail",
              position: 1,
              visible: true,
              editable: false,
              width: "35%",
              searchable: false,
              sorting: true,
              datafield: "thumbnail",
              tobecellsrenderered: function (data_row, row, columnfield, value, defaulthtml, columnproperties) {
                return '<div><img height="80" width="80" style="margin-left: auto; margin-right: auto; display: block;" src="' + data_row.thumb + '"/></div>';
              }
            },
            icon: {
              text: "icon",
              position: 2,
              visible: true,
              editable: false,
              width: "15%",
              searchable: false,
              sorting: true,
              datafield: "icon"
            },
            descr: {
              text: "description",
              position: 3,
              visible: true,
              editable: false,
              width: "50%",
              searchable: false,
              sorting: true,
              datafield: "descr"
            }
          }
        }
      },
      valListCfg: {
        ID: "validityTable",
        title: "ValidityGrid",
        label_title: "",
        columns: {
          configs:{
            from: {
              text: "from",
              position: 1,
              visible: true,
              editable: false,
              width: "50%",
              searchable: false,
              sorting: true,
              datafield: "from"
            },
            to: {
              text: "to",
              position: 1,
              visible: true,
              editable: false,
              width: "50%",
              searchable: false,
              sorting: true,
              datafield: "to"
            }
          }
        }
      },
      attrList: [{
        name: '',
        descr: ''
      }],
      docList: [],
      valList: [],
      valGridOptions:{
        columnsresize: true,
        columnsreorder: true,
        rowsheight: 25,
        theme: "light",
        width: "100%",
        selectionmode: "none",
        showfilterrow: false,
        filterable: true,
        sortable: true,
        pageable: false,
        autoheight: true,
        height: 100,
        rowdetails: true,
        rowdetailstemplate: {
          rowdetails:
            "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
          rowdetailsheight: 250 /* ! 230 + 20 ! */
        },
        /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
        ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
        initrowdetails: "nested",
        rendered: null,
        ready: function(){ //ordinamento tabella all'apertura
          //$('#WrapperGrid').jqxGrid('sortby', 'sor', 'asc');
        }
      },
      docGridOptions:{
        columnsresize: true,
        columnsreorder: true,
        rowsheight: vm.$Components["DocumentsGrid"].options.rowsheight,
        theme: "light",
        width: "100%",
        selectionmode: "none",
        showfilterrow: false,
        filterable: true,
        sortable: true,
        pageable: false,
        autoheight: false,
        height: 160,
        rowdetails: true,
        rowdetailstemplate: {
          rowdetails:
            "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
          rowdetailsheight: 250 /* ! 230 + 20 ! */
        },
        /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
        ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
        initrowdetails: "nested",
        rendered: null,
        ready: function(){ //ordinamento tabella all'apertura
          //$('#WrapperGrid').jqxGrid('sortby', 'sor', 'asc');
        }
      },
      attrGridOptions:{
        columnsresize: true,
        columnsreorder: true,
        rowsheight: 50,
        theme: "light",
        width: "100%",
        selectionmode: "none",
        showfilterrow: false,
        filterable: true,
        sortable: true,
        pageable: false,
        autoheight: true,
        height: 100,
        rowdetails: true,
        rowdetailstemplate: {
          rowdetails:
            "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
          rowdetailsheight: 250 /* ! 230 + 20 ! */
        },
        /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
        ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
        initrowdetails: "nested",
        rendered: null,
        ready: function(){ //ordinamento tabella all'apertura
          //$('#WrapperGrid').jqxGrid('sortby', 'sor', 'asc');
        }
      },
      emptyTyp: true,
      emptyDes: true,
      emptySpe: true,
      emptyPos: true,
      emptyQty: true,
      emptySpi: true,
      emptyPri: true,
      emptyNot: true,
      emptyVal: true,
      emptyDoc: true,
      emptyAttr: true,
      salable: false,

      product: null,
      minQuantity: 1,
      maxQuantity: 9999999,
      multipleCodeForPos: false,
      codeSelected: false,
      selCode:null
    };
  },
  created: function() {
    var vm = this;
    //quando viene cliccato un nodo (dall'albero o dal breadcrumb), imposto il flag
    eventBus.$on("node_clicked", () => {
      vm.ignoreIdle = true;
    });

    eventBus.$on("detail_changed", () => {
      vm.$root.showOnlyImg = false;
      vm.$root.styleSupportSidebarIcons();
      vm.init();
    });

    eventBus.$on("nav_to", function(params) {
      vm.isReloading = true;
    });

    eventBus.$on("changeView", (view) => {
      vm.layout = view;
    });

    eventBus.$on("hotspot_tapped", (pos) => {
      vm.selCode = null
      /* vm.$nextTick(function() {
        vm.codeSelected = false
      }); */
      var tapped = vm.activeData.children.filter((elem)=>{
        return elem.pos  == pos;
      })
      if(tapped.length==1){
        vm.multipleCodeForPos = false;
        vm.codeSelected = true
        vm.setModalTabsValues(tapped[0])
      }else{
        vm.multipleCodeForPos = true;
        vm.modalTitle = vm.$Jed.firstUpperTranslate('position')+' '+pos
        vm.tableModalInputConfigs.type.val = vm.$Jed.firstUpperTranslate('code')
        vm.emptyTyp = false
        vm.emptyDes = true
        vm.emptySpe = true
        vm.emptyPos = true
        vm.emptyQty = true
        vm.emptySpi = true
        vm.emptyPri = true
        vm.emptyNot = true
        vm.emptyVal = true
        vm.emptyDoc = true
        vm.emptyAttr = true
        vm.salable = false
        vm.codeSelected = false
        vm.codiciList = tapped
      }
      vm.APITabModal.open();
    });

    eventBus.$on("openDetailModal", (obj) => {
      vm.selCode = null
      /* vm.$nextTick(function() {
        vm.codeSelected = false
      }); */
      var clicked = vm.activeData.children.filter((elem)=>{
        return elem.pos == obj.pos;
      })
      var codeClicked = vm.activeData.children.filter((elem)=>{
        return elem.sid == obj.sid;
      })

      if(clicked.length==1){
        vm.multipleCodeForPos = false;
        vm.codeSelected = true
        vm.setModalTabsValues(clicked[0])
      }else{
        //ho più di un codice relativo a quella posizione
        //se la configurazione è vera, mostro la finestra di selezione del codice
        if(vm.$Behaviors.productSelectionDialog){
          vm.multipleCodeForPos = true;
          vm.modalTitle = vm.$Jed.firstUpperTranslate('position')+' '+obj.pos
          vm.tableModalInputConfigs.type.val = vm.$Jed.firstUpperTranslate('code')
          vm.emptyTyp = false
          vm.emptyDes = true
          vm.emptySpe = true
          vm.emptyPos = true
          vm.emptyQty = true
          vm.emptySpi = true
          vm.emptyPri = true
          vm.emptyNot = true
          vm.emptyVal = true
          vm.emptyDoc = true
          vm.emptyAttr = true
          vm.salable = false
          vm.codeSelected = false
          vm.codiciList = clicked
        }else{
          //in questo caso apro direttamente il dettaglio del codice relativo alla riga cliccata
          vm.multipleCodeForPos = false;
          vm.codeSelected = true
          vm.setModalTabsValues(codeClicked[0])
        }
      }
      vm.APITabModal.open();
    });
  },
  watch: {
    "$route.params.id": function() {
      //ignore idle true quando il cambiamento nel paramentro di routing avviene o da side-tree (click o navigateTo)
      if (this.ignoreIdle) {
        this.ignoreIdle = false;
      } else {
        //quando cambia il parametro nell'url (ho cliccato <- nel browser)
        //navigo al nodo che è passato come parametro nell'url
        var id = this.$root.decode(this.$route.params.id)
        this.$root.navigateTo(id);
      }
    },
    "$route.params.focus": function() {
      //quando cambia il parametro nell'url (ho cliccato <- nel browser)
      this.focusChangeDetected();
    }
  },
  beforeDestroy: function(){ 
    this.$emit("closesupport", false);
  },
  methods: {
    init: function() {
      this.layout = null
      this.activeData = this.$store.getters.getActive;
      this.activeData.father.def = this.activeData.father.def!=null ? this.activeData.father.def.toString(): null
      if(this.activeData.father.def){
        this.layout = this.layoutMap[this.activeData.father.def]
      }
      if(!this.layout) this.layout = front_end_configs.default_view;
      eventBus.$emit("defaultView", this.layout);
      this.isReloading = false;
    },
    focusChangeDetected: function() {
      this.focus = this.$route.params.focus;
    },
    setModalTabsValues: function(obj){
      console.log(obj)
      if(obj){
        
        this.emptyTyp = false
        this.emptyDes = false
        this.emptySpe = false
        this.emptyPos = false
        this.emptyQty = false
        this.emptySpi = false
        this.emptyPri = false
        this.emptyNot = false
        this.emptyVal = false
        this.emptyDoc = false
        this.emptyAttr = false

        var lid = this.$root.token.siglaLingua;

        if(obj.salable){
          this.salable=true
          this.product = {
            //typ: elem.typ,
            cod: obj.sid,
            //spi: elem.spi,
            qty: 1,
            descr: obj.des,
            unitmis: obj.uni,
            refObj: obj
          }
        }else{
          this.salable=false
        }

        var prod_type = this.$root.prod_icons[obj.typ];

        this.modalTitle = '<i class="'+ prod_type.icn +'""></i>' + " " + obj.sid + " - " + obj.des; 
        
        this.$nextTick(function(){
          if(obj.qca){
            $("#modalquantitaId").val(obj.qca);
          }else{
            var qty = obj.mqt;
            $("#modalquantitaId").val(qty);
          }
          $("#modalquantitaId").attr('min', obj.mqt);
          $("#modalquantitaId").attr('max', this.maxQuantity);
          this.manageCounter();

          this.valList = [];
          for(var v in obj.val){
            var va = obj.val[v]
            if(this.$Behaviors.updatesReference == 'serial'){
              this.valList.push({
                  'from': va.sv ? va.sv : '',
                  'to': va.ev ? va.ev : '',
                }
              )  
            }else if(this.$Behaviors.updatesReference == 'date'){
              this.valList.push({
                  'from': va.sv && new Date(va.sv) instanceof Date && !isNaN(new Date(va.sv)) ? new Date(va.sv).toLocaleDateString() : '',
                  'to': va.ev && new Date(va.ev) instanceof Date && !isNaN(new Date(va.ev)) ? new Date(va.ev).toLocaleDateString() : '',
                }
              )
            }
          }
          if(this.valList.length==0){
            this.emptyVal = true;
          }else{ 
            this.emptyVal = false;
          }

          this.docList = [];

          for(var d in obj.doc){
            var doc = obj.doc[d],
                tipo = this.$root.doc_types[doc.tyd],
                dtd = tipo.des[this.$root.token.siglaLingua] ? tipo.des[this.$root.token.siglaLingua] : tipo.des[this.$root.token.defaultLang],
                fname = doc.na.replace(/\.[^/.]+$/, ""),
                descrip = this.$Behaviors.useClientDocumentType ? dtd : fname,
                url = this.$root.msPath + '/' + this.$Configs.licenseId + '/doc/tn/' + fname + '_TN.jpg';

            this.docList.push({
              'thumb': url,
              'icon': doc.icn,
              'descr': descrip
              }
            )
          }
          if(this.docList.length==0){
            this.emptyDoc = true;
          }else{
            this.emptyDoc = false;
          }

          this.attrList = [];
          if(obj.att_o){
            for(var i=0; i<obj.att_o.length; i++){
              var att = obj.att_o[i];
              this.attrList.push({
                'name': att.nam[lid],
                'descr': att.des[lid]
              })
            }
          }
          if(this.attrList.length==0){
            this.emptyAttr = true;
          }else{
            this.emptyAttr = false;
          }

          //valorizzo i campi del detail
          if(obj.typ){
            this.tableModalInputConfigs.type.val = prod_type ? prod_type.des[lid] ? prod_type.des[lid] : prod_type.des[this.$Configs.defaultLang] : this.$Jed.firstUpperTranslate('code')
            this.emptyTyp = false
          }else{
            this.emptyTyp = true
          } 
          
          if(obj.sid){
            this.tableModalInputConfigs.type.cod = obj.sid 
          }
          
          if(obj.des){
            if(obj.des.length > 55){
              this.tableModalInputConfigs.description.rows = "3";
            }else{
              this.tableModalInputConfigs.description.rows = "1";
            }
            this.tableModalInputConfigs.description.val = obj.des;
          }else{
            this.emptyDes = true;
          } 

          if(obj.spe){
            if(obj.spe.length > 60){
              this.tableModalInputConfigs.feature.rows = "3";
            }else{
              this.tableModalInputConfigs.feature.rows = "1";
            }
            this.tableModalInputConfigs.feature.val = obj.spe;
          }else{
            this.emptySpe = true;
          }

          if(obj.pos){
            this.tableModalInputConfigs.position.val = obj.pos 
            this.emptyPos = false
          }else{
            this.emptyPos = true
          } 

          if(obj.qty){
            this.tableModalInputConfigs.quantity.val = obj.qty 
            this.emptyQty = false
          }else{
            this.emptyQty = true
          } 

          if(obj.spi){
            this.tableModalInputConfigs.codSost.val = obj.spi 
            this.emptySpi = false
          }else{
            this.emptySpi = true
          } 
          
          if(obj.pri || obj.origin){ //empty String is false
            var pp = (obj.pri ? obj.pri : obj.origin ? obj.origin : "")
            pp = pp.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            var csy = obj.csy ? obj.csy : this.$root.token.valuta
            this.tableModalInputConfigs.price.val = pp + ' ' + csy
            this.emptyPri = false
          }else{
            this.emptyPri = true
          } 

          var notP = obj.not && obj.not!=" ",
              notN = obj.notc && obj.notc!=" ";
          if(notP || notN){ //se c'è una delle due note, preparo il campo note
            this.emptyNot = false
            if(notP && notN){ //se ci sono entrambe
              this.tableModalInputConfigs.not.val = obj.not + '\r' + obj.notc;
              this.tableModalInputConfigs.not.rows = (obj.not.length + obj.notc.length) > 60 ? "3" : "1"
            }else{
              this.tableModalInputConfigs.not.rows = notP ? obj.not.length>60 ? "3" : "1" : obj.notc.length>60 ? "3" : "1";
              this.tableModalInputConfigs.not.val = notP ? obj.not : obj.notc;
            }
          }else{
            this.emptyNot = true
          }            
        })
      }
    },
    manageCounter: function(){
      var vm = this;
      //soruce: www.codeply.com/go/2VmBU7TanF/bootstrap-plus-minus-counter-input
      $('.btn-number-modal').unbind().click(function(e){ //unbind() per evitare che l'evento si propaghi per più volte
        var fieldName = $(this).attr('data-field'),
            type = $(this).attr('data-type'),
            input = $("input[name='"+fieldName+"']"),
            currentVal = parseFloat(input.val()),
            min = input.attr('min'),
            max = input.attr('max');
        if (!isNaN(currentVal)) {
            if(type == 'minus-modal') {
                if(currentVal > min) {
                  if(vm.product.refObj.mqd){
                    input.val((currentVal - 0.1).toFixed(1)).change();
                  }else if(vm.product.refObj.pib){
                    input.val(currentVal - vm.product.refObj.pib).change();
                  }else{
                    input.val(currentVal - 1).change();
                  }
                } 
                if(parseFloat(input.val()) == min) {
                    $(this).attr('disabled', true);
                }
            } else if(type == 'plus-modal') {
                if(currentVal < max) {
                  if(vm.product.refObj.mqd){
                    input.val((currentVal + 0.1).toFixed(1)).change();
                  }else if(vm.product.refObj.pib){
                    input.val(currentVal + vm.product.refObj.pib).change();
                  }else{
                    input.val(currentVal + 1).change();
                  }
                }
                if(parseFloat(input.val()) == max) {
                    $(this).attr('disabled', true);
                }
            }
        } else {
            input.val(0);
        }
      });

      $('.input-number-modal').focusin(function(){
        $(this).data('oldValue', $(this).val());
      });

      $('.input-number-modal').change(function() {
        var minValue =  parseFloat($(this).attr('min')),
            maxValue =  parseFloat($(this).attr('max')),
            valueCurrent = parseFloat($(this).val()),
            name = $(this).attr('name');
        if(valueCurrent % 1 != 0){ //il valore inserito è decimale?
          if(vm.product.refObj.mqd){
            if(valueCurrent >= minValue) {
              $(".btn-number-modal[data-type='minus-modal'][data-field='"+name+"']").removeAttr('disabled')
            }else{
              console.log('nodew - the minimum value was reached');
              $(this).val($(this).data('oldValue'));
            }
            if(valueCurrent <= maxValue) {
              $(".btn-number-modal[data-type='plus-modal'][data-field='"+name+"']").removeAttr('disabled')
            }else{
              console.log('nodew - the maximum value was reached');
              $(this).val($(this).data('oldValue'));
            }
          }else{
            $(this).val(vm.minQuantity);
          }
        }else{
          if(vm.product.refObj.pib && (valueCurrent % vm.product.refObj.pib != 0)){ //il valore non è multiplo dei pezzi per confezione
            var mult = parseInt(valueCurrent / vm.product.refObj.pib)
            var correct = vm.product.refObj.pib * mult
            $(this).val(correct);
          }
          if(valueCurrent >= minValue) {
            $(".btn-number-modal[data-type='minus-modal'][data-field='"+name+"']").removeAttr('disabled')
          }else{
            console.log('nodew - the minimum value was reached');
            $(this).val($(this).data('oldValue'));
          }
          if(valueCurrent <= maxValue) {
            $(".btn-number-modal[data-type='plus-modal'][data-field='"+name+"']").removeAttr('disabled')
          }else{
            console.log('nodew - the maximum value was reached');
            $(this).val($(this).data('oldValue'));
          }
        }
        
      });

      $(".input-number-modal").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if(vm.product.refObj.mqd){ //permetto l'inserimento di punti e virgole
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190, 110, 188]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) || 
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
          }
        }else{
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) || 
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
          }
        }
        
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      });
    },
    /**
     * mette in carrello il prodotto nella quantità specificata
     */
    putInCart: function(){
      var vm = this,
          cond = false;
      if(this.$root.preferences.useOffline){
        var len = vm.$root.dbServRegistry.collections.length != vm.$root.front_end_configs.collectionsInServReg
        var len2 = vm.$root.dbRegistry.collections.length != vm.$root.front_end_configs.collectionsInIdb
        cond = vm.$root.dbServRegistry == null || vm.$root.dbRegistry == null || len || len2
      }
      if(vm.$root.shopCartData == null){
        /* eventBus.$emit('alert', {
            message: vm.$Jed.firstUpperTranslate('unable to start cart'), 
            type: "warning" 
        })
        return */
        if(!vm.$Configs.ecp.ecidUrl){
          vm.$root.newCart('start'); //se è stato passato il link e-commerce, non inizializzo il carrello
        }
        var tempId = this.$root.getTempReferenceId();
      }
      if(cond){
        eventBus.$emit('alert', {
            message: vm.$Jed.firstUpperTranslate('your data are loading. Try again in a few seconds.'), 
            type: "warning" 
        })
        return;
      }else{
        if(this.product != null) {
          this.product.qty = parseFloat($("#modalquantitaId").val());
          this.minQuantity = this.product.refObj.mqt
          if( this.product.qty < this.minQuantity || this.product.qty > this.maxQuantity){
            //alert('Superata la quantità minima o massima ammessa per questo prodotto');
            eventBus.$emit('alert', {
              message: this.$Jed.firstUpperTranslate('Warning: minimum quantity is %1$s', null, {key: null, string: this.minQuantity}),
              type: "warning",
              action: ''
            })
            return;
          }
          var qty = this.$root.addProductToCart(this.product);
          this.$root.saveDraft();
          eventBus.$emit("refreshDynTableGridValues", qty, this.product.refObj);
          this.APITabModal.close();
        }
      }
    },
    onCodeSelected: function(value){
      if(value){
        this.codeSelected = true
        this.setModalTabsValues(value)
      }
    }
  }
};
</script>
<style>

  .form-detail-field{
    margin-bottom: 1px;
  }

  .form-detail{
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 2px;
    padding-bottom: 2px;
    height: 28px;
    margin: 1px;
  }

  #detailModal .sweet-content-content, #fatherDetailModal .sweet-content-content{
    background-color: #dcebf5;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  #contenttableAttributesGrid .jqx-grid-cell-left-align{
    white-space: initial;
    padding-bottom: 2px;
    text-align: left;
    margin-right: 2px;
    margin-left: 4px;
    margin-top: 8px !important;
    color: #abaeb1;
  }

</style>


// WEBPACK FOOTER //
// src/components/views/NodeWrapper.vue?7f4e335a